var path = 'modules/dcb-eaccount.pages.eadashboard/components/miniAdvertising.tpl.html';
var html = "<div ng-controller=\"SmallAdvertisingController as controller\" ng-init=\"controller.ownInit(cadid)\">\n  <div class=\"portlet-body portlet-mini\" style=\"cursor:pointer;\" ng-click=\"controller.toggleSetting();\">\n    <div class=\"best-pay-small best-pay-center\">\n      <span i18n=\"advertisement.portlet.line1\">SMART TEILZAHLEN</span>\n    </div>\n  </div>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./~/ngtemplate-loader?relativeTo=/src/ui/modules/eaDashboard/components&prefix=modules/dcb-eaccount.pages.eadashboard/components!./~/raw-loader!./src/ui/modules/eaDashboard/components/miniAdvertising.tpl.html
// module id = 904
// module chunks = 12